<template>
    <div>
      <h2 class="text-center mb-4">Media Details</h2>
      <div v-if="media && media.length">
        <div v-for="(user, index) in media" :key="index">
          <h3>{{ user.username }} (Device: {{ user.device_id }})</h3>
          <div class="row">
            <!-- Loop through the media items for each user -->
            <div
              v-for="(item, itemIndex) in user.media"
              :key="itemIndex"
              class="col-md-4 mb-4"
            >
              <div class="card">
                <div class="card-body">
                  <!-- Display media as an image or video based on its type -->
                  <div class="media-container mb-3">
                    <img
                      :src="item.media_url"
                      alt="Media"
                      v-if="item.media_url && !item.media_url.includes('video')"
                      class="img-fluid"
                      style="max-width: 100%; max-height: 200px; object-fit: cover;"
                    />
                    <video
                      v-if="item.media_url && item.media_url.includes('video')"
                      controls
                      class="img-fluid"
                      style="max-width: 100%; max-height: 200px; object-fit: cover;"
                    >
                      <source :src="item.media_url" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
  
                  <p><strong>Media Name:</strong> {{ item.media_name }}</p>
                  <p><strong>Time Spent:</strong> {{ item.time_sum }}</p>
                  <p><strong>Media Count:</strong> {{ item.count }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Loading state if media is still being fetched -->
      <div v-else>
        <p>Loading media details...</p>
      </div>
    </div>
  </template>
  
  <script>
  import MediaHistoryService from "../../services/MediaHistoryService.js";
  
  export default {
    data() {
      return {
        media: null,
      };
    },
    created() {
      const userId = this.$route.params.userId;
      this.getMediaDetails(userId);
    },
    methods: {
      getMediaDetails(userId) {
        MediaHistoryService.getById(userId)
          .then(response => {
            this.media = response.data;
          })
          .catch(error => {
            console.error(error);
          });
      },
    },
  };
  </script>
  
  <style scoped>
  h2 {
    font-size: 2rem;
    color: #333;
  }
  
  .media-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .card {
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .card-body {
    padding: 15px;
  }
  
  .card img,
  .card video {
    max-width: 100%;
    border-radius: 8px;
  }
  
  .card p {
    font-size: 1rem;
    color: #555;
  }
  
  .row {
    display: flex;
    flex-wrap: wrap;
  }
  
  .col-md-4 {
    flex: 0 0 33.3333%; /* 3 items per row */
    max-width: 33.3333%;
  }
  
  @media (max-width: 767px) {
    .col-md-4 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
  </style>
  